import React from 'react';
import CollectionDatasetCardItem from '../containers/CollectionDatasetCardItem';

const CollectionDatasetCardItems = ({ category, code, items }) => (items.map((item, index) => (
  <CollectionDatasetCardItem
    key={`collection_datasets_list_item_${item.id}`}
    category={category}
    code={code}
    dataset={item}
    upward={index > 4}
  />
)));

export default CollectionDatasetCardItems;
